<template>
    <!-- 配置片段组件，根据条件显示不同的样式类 -->
    <div class="configPiece" :class="[lineAnd ? 'lineAnd' : '', lineContent ? 'lineContent' : '']">
        <!-- 添加条件按钮栏 -->
        <div class="common_btnBar">
            <el-button type="primary" @click="addData">{{ $t('ruleConfig.addCondition') }}</el-button>
        </div>
        <!-- 配置表格区域，当formData长度大于1时添加特殊样式 -->
        <div :class="[Object.keys(formData).length > 1 ? 'configTableClass' : '']">
            <commonTable ref="configTable" />
        </div>
        <!-- 添加字段弹窗组件 -->
        <addField ref="addField" @dialogCloseHandle="dialogCloseHandle" :addFieldDialogVisible="addFieldDialog"
            @insertData="insertData" :tableList="formData" :dataList="fieldList" :getDataList="getDataList" />
    </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import addField from './addField.vue';
import { TableRow, TableColumns } from '@/utils/tableOptions.js';
export default {
    name: 'configPiece',
    components: {
        commonTable,
        addField
    },
    props: {
        // 表单数据对象
        formData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        // 是否显示"且"连接线
        lineAnd: {
            type: Boolean,
            default: false
        },
        // 是否显示"且"文字内容
        lineContent: {
            type: Boolean,
            default: false
        },
        // 字段列表
        fieldList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        // 获取数据列表
        getDataList: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            // 控制添加字段弹窗显示状态
            addFieldDialog: false
        }
    },
    mounted() {
        // 组件挂载后加载表格并初始化数据
        this.loadTable();
        // 遍历formData，将已有数据插入表格
        for (let i in this.formData) {
            const data = this.formData[i].data
            this.insertData(data, true)
        }
    },
    methods: {
        // 加载表格配置
        loadTable() {
            let tableRow = new TableRow();
            // 添加条件名称列
            tableRow.push(
                new TableColumns()
                    ._width('14%')
                    ._title(this.$t('ruleConfig.conditionName'))
                    ._data('label')
            );

            // 注释掉的条件值列配置
            // tableRow.push(
            //     new TableColumns()
            //         ._width('72%')
            //         ._title(this.$t('ruleConfig.conditionValue'))
            //         ._data('conditionValue')
            // );
            
            // 添加条件值列，使用自定义DOM渲染
            tableRow.push(
                new TableColumns()
                    ._width('72%')
                    ._title(this.$t('ruleConfig.conditionValue'))
                    ._cellType('customDom')
                    ._cellData({
                        formater: ({ row, column }) => {
                            // 多选框类型渲染
                            if (row.type === 'checkbox') {
                                return (
                                    <div>
                                        <el-checkbox-group
                                            v-model={this.formData[row.prop].value}
                                            onChange={val => {
                                                this.formData[row.prop].value = val;
                                            }}
                                        >
                                            {
                                                row.options.map(option => {
                                                    return (
                                                        <el-checkbox key={option.id} label={option.value}>
                                                            {option.label}
                                                        </el-checkbox>
                                                    )
                                                })
                                            }
                                        </el-checkbox-group>
                                    </div>
                                )
                            }
                            // 单选+输入框类型渲染
                            if (row.type === 'checkinput') {
                                return (
                                    <div>
                                        <el-row class='inLineFlex'>
                                            <el-col span={6}>
                                                <el-radio-group
                                                    v-model={this.formData[row.prop].value.radio}
                                                >
                                                    <el-radio label='>'>大于</el-radio>
                                                    <el-radio label='<'>小于</el-radio>
                                                </el-radio-group>
                                            </el-col>
                                            <el-col span={12}>
                                                <el-input
                                                    v-model={this.formData[row.prop].value.input}
                                                    onInput={(val) => { this.inviterNumFilter(row.prop, val) }}
                                                    ></el-input>
                                                </el-col>
                                        </el-row>
                                    </div >
                                )
                            }
                            // return (row.dataDom);
                        }
                    }),
            );
            
            // 添加操作列
            tableRow.push(
                new TableColumns()
                    ._width('14%')
                    ._title(this.$t('general.Operation'))
                    ._cellType('customDom')
                    ._cellData({
                        formater: ({ row, column }) => {
                            return (
                                <div>
                                    <el-button type="text" onClick={() => { this.removeRow(row, column) }}>
                                        {this.$t("btn.Delete")}
                                    </el-button>
                                </div>
                            );
                        }
                    }),
            );

            // 设置表格列配置
            let column = tableRow._cols();
            this.$refs.configTable.setColumn(column, {
                resizable: true,
                page: false
            });
        },
        // 删除行数据
        removeRow(row, column) {
            this.$refs.configTable.staticRemoveRow(row)
            this.$delete(this.formData, row.prop)
        },
        // 添加数据，打开添加字段弹窗
        addData() {
            this.addFieldDialog = true
            // this.insertData()
        },
        // 插入数据到表格和formData
        insertData(data, cache) {
            // 如果不是缓存数据，则初始化formData
            if (!cache) {
                if (data.type === 'checkbox') {
                    // 多选框类型，初始化为空数组
                    this.$set(this.formData, data.prop, { data: data, value: [] })
                }
                if (data.type === 'checkinput') {
                    // 单选+输入框类型，初始化为空字符串
                    this.$set(this.formData, data.prop, {
                        data: data,
                        value: {
                            radio: "",
                            input: ""
                        }
                    })
                }
            }
            // 插入行到表格，深拷贝数据避免引用问题
            this.$refs.configTable.insertRow(JSON.parse(JSON.stringify(data)), 0)
        },
        // 弹窗关闭处理
        dialogCloseHandle() {
            this.addFieldDialog = false
        },
        // 数字输入过滤，只允许数字且不超过9999
        inviterNumFilter(prop, val) {
            let numVal = val.replace(/[^\d]/g, '');
            const num = parseInt(numVal) || 0;
            // 如果大于9999则置为9999
            if (numVal > 9999) {
                numVal = 9999
            }
            this.$set(this.formData[prop].value, 'input', numVal);
        },
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/common";

// 配置片段容器样式
.configPiece {
    margin: 10px 0;
    border: 1px solid #eee;
    padding: 10px 0;
    position: relative;
}

// "且"连接线样式
.lineAnd::after {
    position: absolute;
    left: -14px;
    top: 50%;
    transform: translateY(-50%);
    content: "";
    width: 14px;
    height: 1px;
    background-color: #424c57;
}

// "且"文字内容样式
.lineContent::before {
    color: #424c57;
    content: "且";
    position: absolute;
    left: -14px;
    top: -6px;
    transform: translateY(-50%);
}

// 内联弹性布局样式
.inLineFlex {
    display: flex;
    align-items: center;
}

// 配置表格特殊样式类
.configTableClass {
    width: 100%;

    ::v-deep .vxe-table {
        .vxe-body--row {
            position: relative;
        }

        // 每行第一列前显示"或"连接线
        .vxe-body--row .vxe-body--column:first-child:before {
            color: #424c57;
            content: "或";
            position: absolute;
            left: 4px;
            top: 0;
            transform: translateY(-50%);
        }

        // 第一行不显示"或"连接线
        .vxe-body--row:first-child .vxe-body--column:first-child:before {
            display: none;
        }

        .vxe-cell--label {
            position: relative;
        }

        // 标签前的连接线样式
        .vxe-cell--label::before {
            position: absolute;
            left: -16px;
            top: 50%;
            transform: translateY(-50%);
            content: "";
            width: 14px;
            height: 1px;
            background-color: #424c57;
        }
    }
}
</style>